export function getTotalAndCompletedSteps(
  completedSetupSteps:
    | {
        hasGeneralData: boolean;
        hasReportingData: boolean;
        hasProjectsAndDeliverables: boolean;
        hasInvitedUsers: boolean;
        hasNotifications: boolean;
      }
    | undefined
) {
  const totalSteps = Object.entries(completedSetupSteps || {}).length;
  const completedSteps = Object.values(completedSetupSteps || {}).reduce(
    (acc, curr) => {
      if (curr) {
        acc++;
      }

      return acc;
    },
    0
  );
  return { totalSteps, completedSteps };
}
